import '~/bootstrap'
import 'babel-polyfill'
import 'vuetify/src/stylus/app.styl'
import '~/plugins'
import store from '~/store'
import App from '~/App.vue'
import router from './router'
import Vue from 'vue'

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY hh:mm')
  }
})

// Google Analytics
const id = window.location.hostname === 'pantybay.com' ? 'UA-83000542-1' : 'UA-83000542-2'
import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id,
  router
})

window.vm = new Vue({
  el: '#app',
  store,
  router,
  channel: 'public',
  echo: {
    //'StatusEvent': (payload, vm) => {
    //  console.log(payload);
    //}
  },
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./resources/js/app.js